export const ENTER_KEY_CODE = 13;
export const ESCAPE_KEY_CODE = 27;
export const SPACE_KEY_CODE = 32;
export const BACKSPACE_KEY_CODE = 8;
export const MIN_AI_VOICE_SPEED = 0.7;
export const MAX_AI_VOICE_SPEED = 1.2;